<template>
    <div class="app-container">
        <img class="teamShop-bg" src="https://pstatic.navi-sci.cn/groupact_new/pc_teamShop_bg_20241216" alt="">
        <div class="teamShop-content">
            <img v-for="item in teamShop_list" :key="item.id" class="content-item" :src="item.pic"
                @click="toTeamShopDetail(item.id)">
        </div>
    </div>
</template>

<script>
import {getTeamShopList} from "@/api/request";
export default {
    data() {
        return {
            activityId: null,
			teamShop_list: [],
        };
    },
    created() {
        this.activityId = this.$route.query.activityId
        getTeamShopList(this.activityId).then(res=>{
            this.teamShop_list = res.data
        })
    },
    methods: {
        toTeamShopDetail(activityEquipmentId) {
            this.$router.push({
                path: '/teamShopDetail',
                query: {
                    activityEquipmentId
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.teamShop-bg {
    width: 2100px;
    height: 2200px;
}

.teamShop-content {
    position: absolute;
    top: 690px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 1500px;

    .content-item {
        width: 700px;
        margin: 20px 0;
    }
}
</style>
